const countries = {
  COUNTRY_USA: 'common.countries.usa',
  COUNTRY_ISRAEL: 'common.countries.israel',
  COUNTRY_UK: 'common.countries.uk',
  COUNTRY_CANADA: 'common.countries.canada',
};

export default countries;



// WEBPACK FOOTER //
// ./app/javascript/common/country_names.js